import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Fecha/hora en zona America/Caracas, formato es-VE. */
export function formatearFechaHora(iso: string | Date, opciones: Intl.DateTimeFormatOptions = {}): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  return new Intl.DateTimeFormat('es-VE', {
    timeZone: 'America/Caracas',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...opciones,
  }).format(d);
}

export function formatearFecha(iso: string | Date): string {
  return formatearFechaHora(iso, { hour: undefined, minute: undefined });
}

export const ETIQUETA_ROL: Record<string, string> = {
  superadmin: 'Superadmin',
  admin_sucursal: 'Administrador',
  cajero: 'Cajero',
  almacen: 'Almacén',
  contador: 'Contador',
};

export function iniciales(nombre: string): string {
  return nombre
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
